'use client';

import { clsx, type ClassValue } from 'clsx'; // Import clsx itself and ClassValue type
import Link, { type LinkProps } from 'next/link'; // Import LinkProps
import React from 'react';

// Define Anchor props we want to allow, excluding ones managed by LinkProps or className
type AnchorProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps | 'className'>;

// Combine LinkProps, our custom className, and the filtered AnchorProps
interface NavLinkProps extends LinkProps, AnchorProps {
  className?: ClassValue;
  // children will be handled by React.PropsWithChildren
}

export function NavLink({ children, className, href, ...rest }: React.PropsWithChildren<NavLinkProps>) {
  const baseStyles =
    'cursor-pointer inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0';

  return (
    <Link href={href} className={clsx(baseStyles, className)} {...rest}>
      {children}
    </Link>
  );
}
